import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { IconButton, Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, InputLabel } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Rating from '@material-ui/lab/Rating';
import SimpleReactValidator from 'simple-react-validator';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';
import { Link } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class RatingFormDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userCatalogOrdersItemReview: {
                order_item_id: '',
                item_id: '',
                rating: '',
                text: '',
                title: ''
            },
            ratingCount: '',
            loading: false,
        };
        this.resetForm = this.state;
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'invalid-feedback d-block',
        });
    }
 
    handleClose = (e, item = false) => this.props.onClose(item);

    handleChange = (e) => {
        let userCatalogOrdersItemReview = {...this.state.userCatalogOrdersItemReview};
        userCatalogOrdersItemReview[e.target.name] = e.target.value;
        this.setState({userCatalogOrdersItemReview});
    };

    handleRating = (count) => {
        let userCatalogOrdersItemReview = {...this.state.userCatalogOrdersItemReview};
        userCatalogOrdersItemReview['rating'] = `${count}`;
        this.setState({userCatalogOrdersItemReview, ratingCount: count});
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        if( this.validator.allValid() ){
            const { userCatalogOrdersItemReview } = this.state;
            const { dispatch, itemData } = this.props;
            this.setState({loading: true});
            userCatalogOrdersItemReview.order_item_id = itemData.id;
            userCatalogOrdersItemReview.item_id = itemData.item_id;
            //console.log(userCatalogOrdersItemReview, itemData);

            //return false;

            itemService.review("POST", {userCatalogOrdersItemReview}).then(data => {
                if(data.code) {
                    this.props.onClose(true);
                    dispatch(alertSelectors.success(data.message));
                    this.setState({userCatalogOrdersItemReview: {
                        order_item_id: '',
                        item_id: '',
                        rating: '',
                        text: '',
                        title: ''
                    }});
                } else {
                    dispatch(alertSelectors.error(data.errors.message));
                }
                this.setState({loading: false});
            })
            .catch(exception => {
                gs.showErrors(dispatch, exception, alertSelectors);
                this.setState({loading: false});
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        this.validator.purgeFields();
        const { userCatalogOrdersItemReview, ratingCount } = this.state;
        const { open, tutor } = this.props;
        //console.log('this.props', this.props);
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={this.handleClose}
                    scroll={"paper"}
                    TransitionComponent={Transition}
                    keepMounted
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="custom-dialog review"
                >
                    <DialogTitle className="">
                        {/* <Typography variant="h6">&nbsp;</Typography> */}
                        <IconButton aria-label="close" className="closeButton" onClick={this.handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <form name="review_reply" onSubmit={this.handleSubmit} encType="multipart/form-data" noValidate>
                        <DialogContent>
                            <div className="row">
                                <div className="col-lg-7 col-md-9 col-12 mx-auto text-center">
                                    <div className="image text-center">
                                        <img className="img-circle" src={tutor && tutor.avatar} alt="pic" width="70" height="70"/>
                                    </div>
                                        
                                    <h5 className="mt-4"><Link to={`/tutor/view/${tutor && tutor.id}`}>{tutor && tutor.name}</Link></h5>
                                    <div className="rating mb-2">
                                        <span className="star">
                                            {(tutor && tutor.rating_avg) && <Rating name="size-medium" value={parseInt(tutor.rating_avg)} readOnly />}
                                        </span>
                                        <span> ({tutor && tutor.rating_avg}) {tutor && tutor.count_rating} Ratings</span>
                                    </div>
                                    <div className="location">
                                        <i className="fas fa-map-marker-alt"></i> {tutor && tutor.countryCode && tutor.countryCode.name}
                                    </div> 
                                </div>
                            </div>
                            {/* <DialogContentText id="alert-dialog-description"></DialogContentText> */}
                                {/*<div className="form-group">
                                    <InputLabel>Rating</InputLabel>
                                    <Rating name="size-medium" value={userCatalogOrdersItemReview.rating} name="rating" onChange={this.handleChange} />
                                    {this.validator.message('rating', userCatalogOrdersItemReview.rating, 'required')}
                                </div>
                                 <div className="form-group">
                                    <InputLabel>Title</InputLabel>
                                    <TextField 
                                    size="medium" 
                                    value={userCatalogOrdersItemReview.title} 
                                    name="title"
                                    onChange={this.handleChange} />
                                    {this.validator.message('title', userCatalogOrdersItemReview.title, 'required')}
                                </div> */}
                            <div className="rating-view my-4">
                                <ul className="list-group list-group-horizontal">
                                    <li className="">
                                        <div className="smile-icon">
                                            <img src="/images/svg/smile-bad.svg"/>
                                        </div>
                                        <div className={`rating-btn ${(ratingCount === 1) ? 'active' : ''}`}>
                                            <button className={`btn btn-rate`} type="button" onClick={() => this.handleRating(1)}><span>Bad</span><i className="fas fa-star"></i></button>
                                        </div>
                                    </li>
                                    <li className="">
                                        <div className="smile-icon">
                                            <img src="/images/svg/smile-avg.svg"/>
                                        </div>
                                        <div className={`rating-btn ${(ratingCount === 2) ? 'active' : ''}`}>
                                            <button className={`btn btn-rate`} type="button" onClick={() => this.handleRating(2)}><span>Average</span><i className="fas fa-star"></i><i className="fas fa-star"></i></button>
                                        </div>
                                    </li>
                                    <li className="">
                                        <div className="smile-icon">
                                            <img src="/images/svg/smile-good.svg"/>
                                        </div>
                                        <div className={`rating-btn ${(ratingCount === 3) ? 'active' : ''}`}>
                                            <button className={`btn btn-rate`} type="button" onClick={() => this.handleRating(3)}><span>Good</span><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i></button>
                                        </div>
                                    </li>
                                    <li className="">
                                        <div className="smile-icon">
                                            <img src="/images/svg/smile-vgood.svg"/>
                                        </div>
                                        <div className={`rating-btn ${(ratingCount === 4) ? 'active' : ''}`}>
                                            <button className={`btn btn-rate`} type="button" onClick={() => this.handleRating(4)}><span>Very Good</span><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i></button>
                                        </div>
                                    </li>
                                    <li className="">
                                        <div className="smile-icon">
                                            <img src="/images/svg/smile-ex.svg"/>
                                        </div>
                                        <div className={`rating-btn ${(ratingCount === 5) ? 'active' : ''}`}>
                                            <button className={`btn btn-rate`} type="button" onClick={() => this.handleRating(5)}><span>Excellent</span><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i></button>
                                        </div>
                                    </li>
                                </ul>
                                {this.validator.message('rating', userCatalogOrdersItemReview.rating, 'required')}
                            </div>
                            <div className="form-group">
                                <InputLabel className="text-info">Write Review</InputLabel>
                                <textarea 
                                className="form-control"
                                value={userCatalogOrdersItemReview.text} 
                                name="text"
                                onChange={this.handleChange} />
                                {this.validator.message('text', userCatalogOrdersItemReview.text, 'required')}
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <LaddaButton className="btn btn-primary" loading={this.state.loading} data-style={EXPAND_RIGHT}>Submit</LaddaButton>
                            <Button color="primary" onClick={this.handleClose} className="btn btn-secondary">
                                Cancel
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </div>
        );
    }
}


const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(RatingFormDialog);